var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 124,
    viewBox: "0 0 131 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_492",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.7969 -4.99316H233.854V38.282H-25.7969V-4.99316Z",
    fill: "#00732F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.7969 38.2817H233.854V81.5569H-25.7969V38.2817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.7969 81.5571H233.854V124.832H-25.7969V81.5571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.7969 -4.99316H39.1159V124.832H-25.7969V-4.99316Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry3);
export default __webpack_public_path__ + "static/media/country3.30029cdc6b5a4059e256a9448175903a.svg";
export { ForwardRef as ReactComponent };